import { Component, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileServiceService } from '../service/file-service.service';
import { FileCaptureService } from 'app/service/file-capture.service';
import { takeWhile } from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';


@Component({
  standalone: false,
  selector: 'app-email-auth',
  templateUrl: './email-auth.component.html',
  styleUrls: ['./email-auth.component.css']
})
export class EmailAuthComponent implements OnInit {

  authCode = '';
  emailAuthKey = '';
  isValidCode : boolean;
  emailForm: FormGroup = new FormGroup({
    validateEmail: new FormControl(''),
    emailCode: new FormControl('', [Validators.required, Validators.maxLength(6), Validators.pattern(/^\d{6}$/)]),
    contactEmail: new FormControl('', [Validators.required, Validators.maxLength(6), Validators.email])
  });
  disablesumbit: boolean = false;
  isVisible: boolean;
  invalid: boolean;
  captcha: string;
  showCaptcha: boolean | undefined;  
  isValidCodeProgress: boolean = true;
  captchaValidated = false;

  
  constructor(private route: Router, public service: FileServiceService, public fileService: FileCaptureService) {
  }
   ngOnInit() {
    this.emailForm.get('validateEmail')?.setValue(this.service.getCache("contactEmail"));  
    this.emailForm.get('emailCode')?.setValue('');
    if (this.emailForm.get('emailCode')?.value === '' || this.emailForm.get('emailCode')?.value === null) {
      this.disablesumbit = true;
     }
    this.emailForm.get('emailCode')?.valueChanges.subscribe((value) => {
      if (value === '') {
        this.disablesumbit = true;
      } else {
        this.disablesumbit = false;
      }
    });
  }

  next() {
  
    this.route.navigate(['file-upload']);
  }

  close() {
    const sessionId = window.sessionStorage.getItem(this.fileService.SESSION_KEY) || '';
    const payorKey = Number(window.sessionStorage.getItem(this.fileService.PAYOR_KEY) || 0);
    const referenceId = this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');

    this.fileService.releaseActiveReferenceLock(payorKey, referenceId, sessionId).subscribe();

    const refId = this.service.referenceFileDetails.referenceId;
    if (refId) {
      window.localStorage.setItem('referenceId', refId);
    }

    this.service.clearCache();

    const securityCode = window.localStorage.getItem('securityCode');
    if (securityCode) {
      this.route.navigate(['/' + securityCode]);
    } else {
      this.route.navigate(['/dashboard']);
    }
  }



  back() {
    this.route.navigate(['/reference']);
  }

  enableSubmit(){
    this.isValidCodeProgress = false;
  }
  validateCode() {
    this.invalid = false;
    this.isValidCodeProgress = true
    this.isVisible = true;
    var data = {
      emailAuthKey: this.emailForm.get('emailAuthKey')?.value,
      authCode : this.emailForm.get('emailCode')?.value,
      email : this.service.getCache("contactEmail"),
      applicationCode: this.fileService.EMAIL_AUTH_APPLICATION_CODE
    }
    this.fileService.validateCode(data).subscribe(isValidCode => {
      this.isValidCodeProgress = false;
      if(isValidCode){
        this.invalid = false;
        this.service.setAuthenticatedEmail(this.service.getCache("contactEmail"));
        this.next();
      }else{
        this.invalid = true;
      }
      this.isVisible = false;
      
    });
  }


  onCaptchaResolved(response: string) {
    this.captchaValidated = !!response;
    console.log('Captcha resolved:', response);
  }

  captchaEvent(captcha: string) {
    this.captcha = captcha;
  }
    resendCode() {
      const email = this.emailForm.get('validateEmail')?.value;
      const referenceId = this.service.getCache("referenceId");
      const applicationCode = this.fileService.EMAIL_AUTH_APPLICATION_CODE;

      if (!email || !email.includes('@')) {
        alert('Please enter a valid email address.');
        return;
      }

      this.isVisible = true;

      this.fileService.generateCode(email, referenceId, applicationCode).subscribe({
        next: () => {
          this.isVisible = false;
        },
        error: (err) => {
          this.isVisible = false;
          alert('Failed to resend code. Please try again.');
        }
      });
    }

}